import styled from 'styled-components'

type FileInputContainerProps = {
  width?: string | number
  height?: string | number
  $background?: string
  isImageUploaded?: boolean
}

export const FileInputContainer = styled('label')<FileInputContainerProps>`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;

  display: block;
  box-sizing: border-box;
  border: 1px solid #cdcdcd;
  border-radius: 10px;
  min-height: 50px;
  min-width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* cursor: copy; */
  position: relative;
  background-image: ${({ $background }) => ($background ? `url(${$background})` : 'unset')};
  background-size: cover;

  transition: 0.5s ease;
  overflow: hidden;
  /* &::after {
    content: ${({ title }) => (title ? `'${title}'` : 'unset')};
    height: 70px;
    width: 100%;
    background: linear-gradient(transparent, #fff);
    color: #000;
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    text-shadow: 1px 1px 2px #fff;
    transform: translateY(100%);
    transition: all 0.3s;
  } */
  /* &:hover {
    &::after {
      transform: translateY(0%);
    }
  } */
`

export const HiddenInput = styled.input`
  display: none;
`

////////////////////////////////////////////////////////////

export const Placeholder = styled.div`
  background-color: #f4f4f4;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Handlers = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: 0.5s ease;
  position: absolute;
  &:hover {
    transition: 0.5s ease;
    background-color: #00000080;
    opacity: 1;
  }
`

export const Title = styled.p`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  text-shadow: 1px 1px 2px #000;
`
